var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TextField',{attrs:{"fieldName":_vm.fieldName,"fieldDescription":_vm.fieldDescription,"value":_vm.value,"displayLabel":_vm.displayLabel,"disabled":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }